<!-- Reports Tabs-->
<div class="report-tab">
  <ul class="nav nav-pills flex-wrap" id="pills-tab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-summary"
        type="button" role="tab" aria-controls="pills-home" aria-selected="true" (click)="toggleDashboardTabs(true)">
        Summary
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-report" type="button"
        role="tab" aria-controls="pills-profile" aria-selected="false" (click)="toggleDashboardTabs(false)">
        Report
      </button>
    </li>
  </ul>
</div>

<section>
  <div class="reports-container">
    <!--reports filters-->
    <div class="sales-report-filters d-flex flex-wrap gap-2">
      <div class="filter-wrapper flex-grow-1 flex-shrink-1">
        <div class="dropdown mt-1 stores" style="width: 100% !important">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">
              {{ storeName }}
            </small>
            <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>

          <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownMenuButton" style="width: 100%">
            <ul>
              <li (click)="selectAllStores()">
                <a class="dropdown-item">All stores</a>
              </li>
              <li *ngFor="let str of this.stores" (click)="setFilterNames(str, 1)">
                <a class="dropdown-item">{{ str.storeName }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-wrapper flex-grow-1 flex-shrink-1">
        <div class="dropdown mt-1 departments" style="width: 100% !important">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">{{ deptName }}</small>
            <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>

          <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownMenuButton" style="width: 100%">
            <ul>
              <!-- Select All Option -->
              <li style="border-bottom: 1px solid #d4d4d4">
                <a class="dropdown-item">
                  <div class="form-check d-flex" style="cursor: pointer">
                    <input class="form-check-input" type="checkbox" id="selectAllCheckbox"
                      [checked]="headerCheckboxSelected" (change)="toggleAllCheckboxes()" />
                    <label class="form-check-label" for="selectAllCheckbox">
                      Select all Departments ({{
                      mainDepartmentList.length
                      ? mainDepartmentList.length
                      : 0
                      }})
                    </label>
                  </div>
                </a>
              </li>

              <!-- Department List -->
              <li *ngFor="let dept of mainDepartmentList; let i = index">
                <a class="dropdown-item">
                  <div class="form-check d-flex" style="cursor: pointer">
                    <input class="form-check-input" type="checkbox" [id]="'deptCheckbox' + i"
                      [checked]="dept.isSelected" (change)="setFilterNames(dept, 2)" />
                    <label class="form-check-label" [for]="'deptCheckbox' + i">
                      {{ dept.departmentDescr }}
                    </label>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-wrapper flex-grow-1 flex-shrink-1" [ngClass]="{ disabled: disableCategory }">
        <div class="dropdown mt-1" style="width: 100% !important">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">{{ categoryName }}</small>
            <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>

          <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownMenuButton" style="width: 100%">
            <ul>
              <li (click)="selectAllcategories()">
                <a class="dropdown-item">All Categories</a>
              </li>
              <li *ngFor="let ctg of categorieslist">
                <a class="dropdown-item" (click)="setFilterNames(ctg, 3)">{{
                  ctg.categoryName
                  }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        class="filter-wrapper flex-grow-1 flex-shrink-1"
        [ngClass]="{ disabled: disableSubCategory }"
      >
        <div class="dropdown mt-1" style="width: 100% !important">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">{{ subCategoryName }}</small>
            <button
              class="btn text-nowrap"
              type="button"
              id="dropdownMenuButtonSubCategory"
              aria-expanded="false"
            >
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>

          <div
            class="dropdown-menu p-2 mt-1"
            aria-labelledby="dropdownMenuButtonSubCategory"
            style="width: 100%"
          >
            <ul>
              <li (click)="selectAllSubcategories()">
                <a class="dropdown-item">All Subcategories</a>
              </li>
              <li *ngFor="let subCtg of subCategorieslist">
                <a class="dropdown-item" (click)="setFilterNames(subCtg, 6)">{{
                  subCtg.subCategoryName
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Date range filter -->
      <app-daterange [showAll]="false" (dateRangeSelected)="onDateRangeSelected($event)" id="dateFilter"
        class="appDateRange"></app-daterange>

      <!--week color -->
      <div class="filter-wrapper flex-grow-1 flex-shrink-1" *ngIf="showWeekColor">
        <div class="dropdown mt-1 stores" style="width: 100% !important">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">
              {{ weekColor }}
            </small>
            <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>

          <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownMenuButton" style="width: 100%">
            <ul>
              <li (click)="selectAllcolors()">
                <a class="dropdown-item">All Week Colors</a>
              </li>
              <li *ngFor="let wk of weekColorsList" (click)="setFilterNames(wk, 5)">
                <a class="dropdown-item" [style.backgroundColor]="wk.color">{{
                  wk.displayName
                  }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-wrapper flex-grow-1 flex-shrink-1" *ngIf="isDashboardTab">
        <div class="dropdown mt-1 stores" style="width: 100% !important">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text"> Goal By : {{ goalValueStr }} </small>
            <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>

          <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownMenuButton" style="width: 100%">
            <ul>
              <li *ngFor="let value of this.goalValue" (click)="setFilterNames(value, 4)">
                <a class="dropdown-item">{{ value.goalValue }}</a>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <!-- Employee filter (multi-select) — shown on both the dashboard and report-table tabs -->
      <div class="filter-wrapper flex-grow-1 flex-shrink-1">
        <div class="dropdown mt-1 departments" style="width: unset !important">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">
              Employee :
              {{
              selectedEmployeeNames.length === 0
              ? 'All Employees'
              : selectedEmployeeNames.length === 1
              ? selectedEmployeeNames[0]
              : selectedEmployeeNames[0] + ' +' + (selectedEmployeeNames.length - 1)
              }}
            </small>
            <button class="btn text-nowrap" type="button" id="dropdownEmployeeButton" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>

          <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownEmployeeButton" style="width: 100%">
            <ul>
              <li style="border-bottom: 1px solid #d4d4d4">
                <a class="dropdown-item">
                  <div class="form-check d-flex" style="cursor: pointer">
                    <input class="form-check-input" type="checkbox" id="selectAllEmpCheckbox"
                      [checked]="employeeHeaderSelected" (change)="toggleAllEmployeesCheckboxes()" />
                    <label class="form-check-label" for="selectAllEmpCheckbox">
                      All Employees ({{ employeesList.length }})
                    </label>
                  </div>
                </a>
              </li>

              <li *ngFor="let emp of employeesList; let i = index">
                <a class="dropdown-item">
                  <div class="form-check d-flex" style="cursor: pointer">
                    <input class="form-check-input" type="checkbox" [id]="'empCheckbox' + i"
                      [checked]="selectedEmployeeIds.includes(emp.id)" (change)="setFilterNames(emp, 7)" />
                    <label class="form-check-label" [for]="'empCheckbox' + i">
                      {{ emp.fullName }}
                    </label>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Run Report button pinned to the far-right end -->
      <div class="create-btn run-report-btn c-pt" [class.is-loading]="isRunning" (click)="runReport()">
        <span class="run-spinner" *ngIf="isRunning"></span>
        <img *ngIf="!isRunning" src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
        {{ isRunning ? "Running…" : "Run Report" }}
      </div>

      <!-- more options dropdown -->
      <div class="tab-action-container bg-white ms-2" style="border-radius: 8px; height: 2.6rem">
        <div class="dropdown custom-left">
          <button class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"
            id="removeContent" matTooltip="More Options" matTooltipPosition="above" matTooltipClass="raised-tooltip">
            <img src="assets/Pos-Catalog/ri_more-fill.svg" />
          </button>
          <div class="dropdown-menu h-auto mt-3" id="firstDropdown" style="width: 12rem">
            <div class="second-part">
              <ul class="dropdown-list list-unstyled mb-0">
                <li (click)="reportHasRun && exportToExcel()" style="cursor: pointer" [class.disabled]="!reportHasRun">
                  <a class="dropdown-item"><img class="me-3" src="/assets/Pos-Catalog/arrowup.svg" />Export Report</a>
                </li>
              </ul>
            </div>
            <!-- <div class="fourth-part">
              <ul class="dropdown-list list-unstyled mb-0">
                <li>
                  <a class="dropdown-item"><img class="me-3" src="assets/Pos-Catalog/jam_refresh.svg" />Refresh
                    listing</a>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- empty state: shown until the report is run -->
    <div class="report-empty-state" *ngIf="!reportHasRun">
      <img src="assets/dashboard/noData.svg" alt="" />
      <h5>Ready when you are</h5>
      <p>
        Adjust the filters above, then click <strong>Run Report</strong> to
        generate your employee report.
      </p>
      <div class="create-btn run-report-btn c-pt" (click)="runReport()">
        <img src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
        Run Report
      </div>
    </div>

    <div class="tab-content" id="pills-tabContent" style="position: relative" [hidden]="!reportHasRun">
      <div class="tab-pane fade show active" id="pills-summary" role="tabpanel" aria-labelledby="pills-home-tab"
        tabindex="0">
        <div class="report-dashboard mt-2">
          <!--Reports dashboard-->
          <div style="height: calc(100vh - 250px); overflow: auto">
            <div class="row report-stats mt-4">
              <div class="col-2">
                <div class="card" style="background: #e3f5ff">
                  <div class="card-body">
                    <small>Value</small>
                    <div class="d-flex justify-content-between mt-3">
                      <h4>{{ MainStats.value | currency }}</h4>
                      <div>
                        <small class="me-1">{{
                          MainStats.valueGrowth > 0
                          ? "+" + MainStats.valueGrowth
                          : MainStats.valueGrowth
                          }}%</small>
                        <img [src]="
                            MainStats.valueGrowth > 0
                              ? 'assets/pos/products/ic_upGrowth.svg'
                              : 'assets/pos/products/ic_downGrowth.svg'
                          " />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-2">
                <div class="card" style="background: #e5ecf6">
                  <div class="card-body">
                    <small>Pieces</small>
                    <div class="d-flex justify-content-between mt-3">
                      <h4>{{ MainStats.qty | number }}</h4>
                      <div>
                        <small class="me-1">{{
                          MainStats.qtyGrowth > 0
                          ? "+" + MainStats.qtyGrowth
                          : MainStats.qtyGrowth
                          }}%</small>
                        <img [src]="
                            MainStats.qtyGrowth > 0
                              ? 'assets/pos/products/ic_upGrowth.svg'
                              : 'assets/pos/products/ic_downGrowth.svg'
                          " />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2">
                <div class="card" style="background: #e3f5ff">
                  <div class="card-body">
                    <small>Hours</small>
                    <div class="d-flex justify-content-between mt-3">
                      <h4>
                        {{
                        (MainStats?.totalHoursLogged ?? 0) *
                        ((MainStats?.totalHoursLogged ?? 0) < 0 ? -1 : 1) | number: "1.2-2" }} </h4>

                          <div>
                            <!-- <small class="me-1">+6.08%</small>
        <img src="assets/pos/products/ic_upGrowth.svg" />-->
                          </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2">
                <div class="card" style="background: #e5ecf6">
                  <div class="card-body">
                    <small>$/Hour</small>
                    <div class="d-flex justify-content-between mt-3">
                      <h4>
                        {{
                        (MainStats.totalHoursLogged
                        ? MainStats.value / MainStats.totalHoursLogged
                        : 0
                        ) | currency
                        }}
                      </h4>
                      <div>
                        <!-- <small class="me-1">+6.08%</small>
                     <img src="assets/pos/products/ic_upGrowth.svg" />-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2">
                <div class="card me-0" style="background: #e3f5ff">
                  <div class="card-body">
                    <small>APOP</small>
                    <div class="d-flex justify-content-between mt-3">
                      <h4>
                        {{
                        (MainStats.value
                        ? MainStats.value / MainStats.qty
                        : 0
                        ) | currency
                        }}
                      </h4>
                      <div>
                        <small class="me-1">{{
                          MainStats.apopGrowth > 0
                          ? "+" + MainStats.apopGrowth
                          : MainStats.apopGrowth
                          }}%</small>
                        <img [src]="
                            MainStats.apopGrowth > 0
                              ? 'assets/pos/products/ic_upGrowth.svg'
                              : 'assets/pos/products/ic_downGrowth.svg'
                          " />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--first chart section-->
            <div [hidden]="!isGoalData">
              <div class="d-flex first-chart-section mt-3">
                <div class="container-bg me-3" style="flex-basis: 20%">
                  <small id="dashboardTitlesBold">Projections</small>
                  <div class="store-level-gauge">
                    <ngx-gauge type="semi" [size]="250" [value]="gaugeValue" [thick]="13" cap="round"
                      [foregroundColor]="gaugeColor" class="m-auto" style="position: relative">
                      <ngx-gauge-value class="gauge-container">
                        <div class="gauge-value">{{ gaugeValue }}%</div>
                      </ngx-gauge-value>

                      <ngx-gauge-label> goal achieved </ngx-gauge-label>
                    </ngx-gauge>
                  </div>
                </div>

                <div class="container-bg emp-levels position-relative" style="flex-basis: 80%">
                  <small id="dashboardTitlesBold">Goal - Employee Level</small>

                  <div class="d-flex flex-column justify-content-evenly h-100 pe-3 overflow-auto"
                    [ngClass]="{ hideNoDataFound: !isEmployeLevelData }">
                    <div class="parent">
                      <div
                        class="d-flex align-items-center me-2"
                        *ngFor="let item of empLevel"
                        style="height: fit-content; max-width: 35rem"
                      >
                        <small
                          style="color: #424242; font-size: 12px; min-width: 8.5rem; max-width: 10rem; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; margin-right: 0.5rem;"
                          [title]="item.name"
                          >{{ item.name }}</small
                        >
                        <div
                          class="progress w-100 flex-grow-1 position-relative"
                          style="height: 1.5rem;"
                          [style.background]="item.bg"
                          [ngClass]="{ hideNoDataFound: !isEmployeLevelData }"
                        >
                          <div
                            class="progress-bar"
                            role="progressbar"
                            [style.background]="item.color"
                            [style.width]="item.totalAchieved + '%'"
                            aria-valuenow="item.totalAchieved"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <span *ngIf="item.totalAchieved > 0">{{ item.totalAchieved }}%</span>
                          </div>
                          <span
                            *ngIf="item.totalAchieved === 0"
                            class="position-absolute start-0 ms-2"
                            style="font-size: 11px; line-height: 1.5rem; color: #555; font-weight: 500;"
                          >
                            0%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column text-center justify-content-center h-100 noData"
                    style="flex-basis: 100%" [ngClass]="{ hideNoDataFound: isEmployeLevelData }">
                    <img src="assets/dashboard/noData.svg" style="height: 145px" />
                  </div>
                </div>

                <!-- <div style="flex-basis:50%" class="projections container-bg">
              <small id="dashboardTitlesBold">Projections</small>
              <canvas id="projections" class="mt-3"></canvas>
            </div>-->
              </div>
            </div>

            <!--  Second chart section-->
            <div class="second-chart-section mt-3" [hidden]="!isGoalData">
              <div class="projections container-bg">
                <div class="d-flex justify-content-between">
                  <small id="dashboardTitlesBold">Projections</small>
                  <ul class="legends">
                    <li>
                      <div class="current-data"></div>
                      Current
                    </li>
                    <li>
                      <div class="forecast-data"></div>
                      Forecast
                    </li>
                  </ul>
                </div>

                <div [ngClass]="{ hideNoDataFound: !isProjectionData }">
                  <canvas #projection id="projection" class="mt-3"></canvas>
                </div>

                <div class="d-flex flex-column text-center justify-content-center h-100 noData" style="flex-basis: 100%"
                  [ngClass]="{ hideNoDataFound: isProjectionData }">
                  <img src="assets/dashboard/noData.svg" style="height: 145px" />
                </div>
              </div>
            </div>

            <!--  Third chart section-->
            <div class="second-chart-section mt-3">
              <div class="container-bg total-value">
                <div class="d-flex justify-content-between">
                  <small id="dashboardTitlesBold">Total Value</small>
                  <small id="dashboardTitlesBold">Total: {{ totalValueCollected | currency }}</small>
                </div>
                <div [ngClass]="{ hideNoDataFound: !isTotalValue }">
                  <canvas id="totalValue" class="mt-3"></canvas>
                </div>

                <div class="d-flex flex-column text-center justify-content-center h-100 noData" style="flex-basis: 100%"
                  [ngClass]="{ hideNoDataFound: isTotalValue }">
                  <img src="assets/dashboard/noData.svg" style="height: 145px" />
                </div>
              </div>
            </div>

            <!--Fourth chart section -->
            <div class="second-chart-section mt-3 mb-5">
              <div class="container-bg total-item">
                <div class="d-flex justify-content-between">
                  <small id="dashboardTitlesBold">Total Items Collected</small>
                  <small id="dashboardTitlesBold">Total: {{ totalItemsCollected }} items</small>
                </div>
                <div [ngClass]="{ hideNoDataFound: !isTotalItemData }">
                  <canvas #totalItem id="totalItem" class="mt-3"></canvas>
                </div>
                <div class="d-flex flex-column text-center justify-content-center h-100 noData" style="flex-basis: 100%"
                  [ngClass]="{ hideNoDataFound: isTotalItemData }">
                  <img src="assets/dashboard/noData.svg" style="height: 145px" />
                </div>
              </div>
            </div>
            <!--Fifth chart section -->
            <div class="second-chart-section mt-3 mb-5">
              <div class="container-bg total-item">
                <div class="d-flex justify-content-between">
                  <small id="dashboardTitlesBold">Total Items Pre-Produced</small>
                  <small id="dashboardTitlesBold">Total: {{ totalItemsPreProduced }} items</small>
                </div>
                <div [ngClass]="{ hideNoDataFound: !isPreProducedData }">
                  <canvas #preProduced id="preProduced" class="mt-3"></canvas>
                </div>
                <div class="d-flex flex-column text-center justify-content-center h-100 noData" style="flex-basis: 100%"
                  [ngClass]="{ hideNoDataFound: isPreProducedData }">
                  <img src="assets/dashboard/noData.svg" style="height: 145px" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--loader-->
        <div class="overlay" *ngIf="isLoadingEmpDashboard">
          <div class="loader"></div>
        </div>
      </div>

      <div class="tab-pane fade" id="pills-report" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
        <!--Report table-->
        <div class="report-table-wrapper mt-3" *ngIf="empReportsQtys.length > 0">
          <div class="report-dept-head mt-4">
            <p *ngIf="!disableCategory">{{ reportHead }}</p>
            <p *ngIf="disableCategory">{{ deptName }}</p>
          </div>
          <div class="report-table">
            <table class="table table-bordered mb-0 parent-table">
              <thead>
                <tr class="text-center">
                  <th style="width: 0% !important" class="boxShadow sticky-cols"></th>
                  <th width="40%">APOP</th>
                  <th width="40%" style="background: #424242; color: #fff">
                    Team Total
                  </th>
                </tr>
              </thead>
              <tbody *ngFor="let item of empReportPrices">
                <tr>
                  <td style="font-weight: 500" class="text-start boxShadow sticky-cols">
                    {{ this.empReportPrices[0]?.name }}
                  </td>
                  <td class="p-0">
                    <table class="table w-100 sales-table-nested1">
                      <thead>
                        <tr>
                          <th *ngFor="let prc of item?.prices">
                            {{ prc ?? 0 | currency }}
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </td>

                  <td class="p-0">
                    <table class="table w-100 sales-table-nested2">
                      <thead>
                        <tr>
                          <th>Pieces</th>
                          <th>value</th>
                          <th>Hours</th>
                          <th>$/Hour</th>
                          <th>APOP</th>
                        </tr>
                      </thead>
                    </table>
                  </td>
                </tr>
                <tr *ngFor="let entries of pagedEmpReports">
                  <td class="text-start boxShadow sticky-cols" *ngIf="this.storeId !== 0">
                    {{ entries?.name }}
                  </td>
                  <td class="text-start boxShadow sticky-cols" *ngIf="this.storeId === 0">
                    {{ entries?.store }}
                  </td>
                  <td class="p-0">
                    <table class="table w-100 sales-table-nested1">
                      <tbody>
                        <tr class="text-center">
                          <ng-container *ngFor="let prc of empReportPrices[0]?.prices">
                            <td>
                              {{
                              getFilterQuantity(entries?.qtyArray, prc) !==
                              null
                              ? (getFilterQuantity(entries?.qtyArray, prc)
                              | number)
                              : ""
                              }}
                            </td>
                          </ng-container>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td class="p-0">
                    <table class="table w-100 sales-table-nested2">
                      <tbody>
                        <tr class="text-center">
                          <td>{{ entries?.pieces | number }}</td>
                          <td>{{ entries?.value | currency }}</td>
                          <td>{{ entries?.hours ?? 0.0 }}</td>
                          <td>{{ entries?.valuePerHour ?? 0.0 | currency }}</td>
                          <td>{{ entries?.apop | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr *ngIf="remainingCount > 0">
                  <td colspan="100%" class="text-start">
                    <button class="btn" (click)="loadMore()">Load More</button>
                  </td>
                </tr>
                <tr style="background: #f5f5f5" id="nested-table-totals">
                  <td style="font-weight: 500" class="text-start boxShadow sticky-cols">
                    Totals
                  </td>
                  <td class="p-0">
                    <table class="table w-100 sales-table-nested1">
                      <tbody>
                        <tr class="text-center">
                          <ng-container *ngFor="let prc of empReportPrices[0]?.prices">
                            <td>
                              {{
                              getQuantity(tblReportsTotal?.totalQtyArray, prc)
                              | number
                              }}
                            </td>
                          </ng-container>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td class="p-0">
                    <table class="table w-100 sales-table-nested2">
                      <tbody>
                        <tr class="text-center">
                          <td>{{ tblReportsTotal?.pieces | number }}</td>
                          <td>{{ tblReportsTotal?.value | currency }}</td>
                          <td>
                            {{ tblReportsTotal?.hours ?? 0 | number: "1.2-2" }}
                          </td>
                          <td>
                            {{ tblReportsTotal?.valuePerHour ?? 0 | currency }}
                          </td>
                          <td>{{ tblReportsTotal?.apop ?? 0 | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style="font-weight: 500; min-width: 14rem; width: 12.5rem"
                    class="d-flex p-0 sticky-cols boxShadow">
                    <div class="rotated-text">
                      <small> Team Total </small>
                    </div>
                    <table class="table w-100 mb-0">
                      <tbody>
                        <tr>
                          <td class="text-start">Value</td>
                        </tr>
                        <tr>
                          <td class="text-start">Pieces</td>
                        </tr>
                        <tr>
                          <td class="text-start">Hours</td>
                        </tr>
                        <tr>
                          <td class="text-start">$/Hour</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td class="p-0">
                    <table class="table w-100 sales-table-nested1 mb-0">
                      <tbody>
                        <tr class="text-center">
                          <ng-container *ngFor="let prc of empReportPrices[0]?.prices">
                            <td>
                              {{
                              getColumnWiseTotalPrices(
                              tblReportsTotal?.totalQtyArray,
                              prc
                              ) | currency
                              }}
                            </td>
                          </ng-container>
                        </tr>
                        <tr class="text-center">
                          <ng-container *ngFor="let prc of empReportPrices[0]?.prices">
                            <td>
                              {{
                              getQuantity(tblReportsTotal?.totalQtyArray, prc)
                              | number
                              }}
                            </td>
                          </ng-container>
                        </tr>
                        <tr class="text-center">
                          <ng-container *ngFor="let prc of empReportPrices[0]?.prices">
                            <td>
                              {{
                              getColumnWiseHours(
                              tblReportsTotal?.totalQtyArray,
                              prc
                              ) | number: "1.2-2"
                              }}
                            </td>
                          </ng-container>
                        </tr>
                        <tr class="text-center">
                          <ng-container *ngFor="let prc of empReportPrices[0]?.prices">
                            <td>
                              {{
                              getColumnWiseValueperHour(
                              tblReportsTotal?.totalQtyArray,
                              prc
                              ) | currency
                              }}
                            </td>
                          </ng-container>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--No table data-->
        <div class="no-table-report text-center" *ngIf="reportHasRun && !isLoadingTable && empReportsQtys.length === 0">
          <div class="m-auto">
            <div class="img-container m-auto d-flex">
              <img src="assets/emp reports/ic_noTableData.svg" class="m-auto" />
            </div>

            <p style="color: #9e9e9e" class="mt-4">
              There is no sales summary available yet. <br />
              Please check back later
            </p>
          </div>
        </div>
        <!--loader-->
        <div class="overlay" *ngIf="isLoadingTable">
          <div class="loader"></div>
        </div>
      </div>
    </div>
  </div>
</section>
